import { createStatusReducer } from '../../helpers/reducers';
import { types } from '../../actions/events';
import * as routeTypes from '../../routes/types';

const initialState = 'SUCCESS';

const apiActionTypes = [
  types.EVENTS_SHOW,
];

const routeActionTypes = [
  routeTypes.ROUTE_EVENTS_SHOW,
];

const status = createStatusReducer(initialState, apiActionTypes, routeActionTypes);

export default status;

export const getStatus = state => state.events.status;



// WEBPACK FOOTER //
// ./src/reducers/events/status.js